'use strict'

const ISO_DATE_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/

const digits = (value, length) => String(value || '').replace(/\D/g, '').slice(0, length)

const validCalendarDate = (year, month, day) => {
  const date = new Date(Date.UTC(2000, month - 1, day))
  date.setUTCFullYear(year)

  return date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
}

const normalizeBirthDateParts = ({day, month, year}, maxDate = null) => {
  const normalizedParts = {
    day: digits(day, 2),
    month: digits(month, 2),
    year: digits(year, 4),
  }

  if (!normalizedParts.day && !normalizedParts.month && !normalizedParts.year) {
    return {...normalizedParts, complete: false, valid: true, value: '', reason: null}
  }

  if (!normalizedParts.day || !normalizedParts.month || !normalizedParts.year) {
    return {...normalizedParts, complete: false, valid: true, value: '', reason: null}
  }

  if (normalizedParts.year.length !== 4) {
    return {...normalizedParts, complete: true, valid: false, value: '', reason: 'year'}
  }

  const numericDay = Number(normalizedParts.day)
  const numericMonth = Number(normalizedParts.month)
  const numericYear = Number(normalizedParts.year)

  if (!validCalendarDate(numericYear, numericMonth, numericDay)) {
    return {...normalizedParts, complete: true, valid: false, value: '', reason: 'invalid'}
  }

  const value = `${normalizedParts.year}-${normalizedParts.month.padStart(2, '0')}-${normalizedParts.day.padStart(2, '0')}`
  if (maxDate && value > maxDate) {
    return {...normalizedParts, complete: true, valid: false, value: '', reason: 'future'}
  }

  return {...normalizedParts, complete: true, valid: true, value, reason: null}
}

const splitBirthDate = (value) => {
  if (value instanceof Date && !Number.isNaN(value.getTime())) {
    return {
      day: String(value.getDate()).padStart(2, '0'),
      month: String(value.getMonth() + 1).padStart(2, '0'),
      year: String(value.getFullYear()).padStart(4, '0'),
    }
  }

  const match = String(value || '').slice(0, 10).match(ISO_DATE_PATTERN)
  if (!match) return {day: '', month: '', year: ''}

  const result = normalizeBirthDateParts({year: match[1], month: match[2], day: match[3]})
  if (!result.valid) return {day: '', month: '', year: ''}

  return {day: match[3], month: match[2], year: match[1]}
}

module.exports = {
  normalizeBirthDateParts,
  splitBirthDate,
}
